import React, { useId, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
interface TooltipProps {
  /** Rich content shown on hover/focus — headings and paragraphs allowed. */
  content: React.ReactNode;
  children: (props: {
    'aria-describedby': string;
  }) => React.ReactNode;
  align?: 'center' | 'right';
  width?: string;
}

/** Hover/focus panel anchored above its trigger — used for footer affordances. */
export function Tooltip({
  content,
  children,
  align = 'center',
  width = 'w-72'
}: TooltipProps) {
  const id = useId();
  const [open, setOpen] = useState(false);
  return <span className="relative inline-flex" onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)} onFocus={() => setOpen(true)} onBlur={() => setOpen(false)} data-id="element-207" data-mp="fy71a22ttew0">
      {children({
      'aria-describedby': id
    })}
      <AnimatePresence data-id="element-208" data-mp="2acq5c930nqg5">
        {open && <motion.span role="tooltip" id={id} initial={{
        opacity: 0,
        y: 6,
        scale: 0.97
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 4,
        scale: 0.98
      }} transition={{
        duration: 0.16,
        ease: [0.23, 1, 0.32, 1]
      }} className={`pointer-events-none absolute bottom-[calc(100%+0.65rem)] z-40 block ${width} rounded-lg border border-ink-line bg-ink-panel/95 p-3.5 text-left shadow-2xl shadow-black/60 backdrop-blur ${align === 'right' ? 'right-0 origin-bottom-right' : 'left-1/2 -translate-x-1/2 origin-bottom'}`} data-id="element-209" data-mp="2farn8qophjq1">
            {content}
          </motion.span>}
      </AnimatePresence>
    </span>;
}